<template>
  <div>
    <v-app-bar app flat height="76" class="app-header" :class="{ scrolled: isScrolled }"
      v-scroll="onScroll">
      <v-container class="d-flex align-center py-0 header-inner">
        <router-link to="/" class="brand-logo" aria-label="Turn 10 Racing home">
          <img :src="logo" alt="Turn 10 Racing logo" class="logo-img" />
        </router-link>

        <v-spacer />

        <nav class="menu-items d-none d-md-flex" aria-label="Main">
          <router-link v-for="link in navLinks" :key="link.to" :to="link.to" class="menu-item" exact>
            {{ link.title }}
          </router-link>
        </nav>

        <v-spacer class="d-none d-md-flex" />

        <v-btn :href="site.instagramUrl" target="_blank" rel="noopener" color="primary" depressed
          class="follow-btn d-none d-sm-flex">
          <v-icon left small>mdi-instagram</v-icon>
          Follow Us
        </v-btn>

        <v-app-bar-nav-icon class="d-md-none ml-2" aria-label="Open menu" @click="menuDrawer = !menuDrawer" />
      </v-container>
    </v-app-bar>

    <!-- Mobile drawer for menu -->
    <v-navigation-drawer v-model="menuDrawer" app temporary right width="280" class="mobile-drawer">
      <div class="d-flex align-center justify-space-between pa-4">
        <img :src="logo" alt="Turn 10 Racing logo" class="drawer-logo" />
        <v-btn icon aria-label="Close menu" @click="menuDrawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider />
      <v-list nav>
        <v-list-item v-for="link in navLinks" :key="link.to" :to="link.to" exact color="primary"
          @click="menuDrawer = false">
          <v-list-item-title class="drawer-link">{{ link.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <div class="pa-4">
        <v-btn :href="site.instagramUrl" target="_blank" rel="noopener" color="primary" depressed block>
          <v-icon left small>mdi-instagram</v-icon>
          Follow Us
        </v-btn>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { SITE, NAV_LINKS } from '@/utils/siteConfig';

  export default {
    name: 'header-comp',
    data() {
      return {
        menuDrawer: false,
        isScrolled: false,
        logo: require('@/assets/logo/turn10-logo-sm.png'),
        site: SITE,
        navLinks: NAV_LINKS,
      };
    },
    methods: {
      onScroll() {
        this.isScrolled = window.scrollY > 8;
      },
    },
  };
</script>

<style scoped>
  .app-header.v-app-bar.v-toolbar.v-sheet {
    background: rgba(10, 12, 16, 0.72) !important;
    backdrop-filter: saturate(160%) blur(12px);
    -webkit-backdrop-filter: saturate(160%) blur(12px);
    border-bottom: 1px solid transparent;
    transition: border-color 0.2s ease, background 0.2s ease;
  }

  .app-header.scrolled.v-app-bar.v-toolbar.v-sheet {
    background: rgba(10, 12, 16, 0.92) !important;
    border-bottom-color: var(--t10-border);
  }

  .app-header >>> .v-toolbar__content {
    padding: 0;
  }

  .header-inner {
    height: 100%;
  }

  .brand-logo {
    display: flex;
    align-items: center;
  }

  .logo-img {
    height: 58px;
    width: auto;
    display: block;
  }

  .menu-items {
    gap: 4px;
  }

  .menu-item {
    position: relative;
    padding: 8px 14px;
    color: var(--t10-text-muted);
    text-decoration: none;
    font-family: var(--t10-font-display);
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    transition: color 0.15s ease;
  }

  .menu-item::after {
    content: '';
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: 2px;
    height: 2px;
    background: var(--t10-blue);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.2s ease;
  }

  .menu-item:hover,
  .menu-item.router-link-active {
    color: #fff;
  }

  .menu-item:hover::after,
  .menu-item.router-link-active::after {
    transform: scaleX(1);
  }

  .follow-btn {
    font-family: var(--t10-font-display);
    font-weight: 700;
    letter-spacing: 0.06em;
  }

  .mobile-drawer.v-navigation-drawer {
    background: var(--t10-surface) !important;
  }

  .drawer-logo {
    height: 44px;
    width: auto;
  }

  .drawer-link {
    font-family: var(--t10-font-display);
    font-weight: 600;
    font-size: 17px !important;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
</style>
